<template>
  <SuppliersTable />
</template>

<script>
import SuppliersTable from './components/SuppliersTable.vue'

export default {
  components: {
    SuppliersTable,
  },

  data: () => ({}),

  methods: {},

  created() {},
}
</script>
